const state = {
  //DEMO演示，写死token
  token: window.sessionStorage.getItem("token"),
  name: window.sessionStorage.getItem("name") || "",
  vipType: window.sessionStorage.getItem("vipType") || window.localStorage.getItem("vipType"),
  freeBalance: window.sessionStorage.getItem("freeBalance") || window.localStorage.getItem("freeBalance"),
  timesVipBalance: window.sessionStorage.getItem("timesVipBalance") || window.localStorage.getItem("timesVipBalance"),
  timesVipExpire: window.sessionStorage.getItem("timesVipExpire") || window.localStorage.getItem("timesVipExpire"),
  monthVipExpire: window.sessionStorage.getItem("monthVipExpire") || window.localStorage.getItem("monthVipExpire"),
  //userInfoUserStatus: window.sessionStorage.getItem("userInfoUserStatus") || window.localStorage.getItem("userInfoUserStatus"),
  userStatusDesc: window.sessionStorage.getItem("userStatusDesc") || window.localStorage.getItem("userStatusDesc"),
  vipExpireDesc: window.sessionStorage.getItem("vipExpireDesc") || window.localStorage.getItem("vipExpireDesc"),
  unionId: window.sessionStorage.getItem("unionId") || window.localStorage.getItem("unionId"),
  userId: window.sessionStorage.getItem("userId") || window.localStorage.getItem("userId"),
  nickName: window.sessionStorage.getItem("nickName") || window.localStorage.getItem("nickName"),
  headImgUrl: window.sessionStorage.getItem("headImgUrl") || window.localStorage.getItem("headImgUrl"),
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  login(state, payload) {
    state.unionId = payload.unionId;
    window.sessionStorage.setItem("unionId", payload.unionId);
    window.localStorage.setItem("unionId", payload.unionId);
    state.nickName = payload.nickName;
    window.sessionStorage.setItem("nickName", payload.nickName);
    window.localStorage.setItem("nickName", payload.nickName);
    state.headImgUrl = payload.headImgUrl;
    window.sessionStorage.setItem("headImgUrl", payload.headImgUrl);
    window.localStorage.setItem("headImgUrl", payload.headImgUrl);
    state.userId = payload.userId;
    window.sessionStorage.setItem("userId", payload.userId);
    window.localStorage.setItem("userId", payload.userId);
  },
  updateUserInfo(state, payload){
    //0.免费会员  1.次数会员  2.包月会员
    state.vipType = payload.vipType;
    window.sessionStorage.setItem("vipType", payload.vipType);
    window.localStorage.setItem("vipType", payload.vipType);
    state.freeBalance = payload.freeBalance;
    window.sessionStorage.setItem("freeBalance", payload.freeBalance);
    window.localStorage.setItem("freeBalance", payload.freeBalance);
    state.timesVipBalance = payload.timesVipBalance;
    window.sessionStorage.setItem("timesVipBalance", payload.timesVipBalance);
    window.localStorage.setItem("timesVipBalance", payload.timesVipBalance);
    state.timesVipExpire = payload.timesVipExpire;
    window.sessionStorage.setItem("timesVipExpire", payload.timesVipExpire);
    window.localStorage.setItem("timesVipExpire", payload.timesVipExpire);
    state.monthVipExpire = payload.monthVipExpire;
    window.sessionStorage.setItem("monthVipExpire", payload.monthVipExpire);
    window.localStorage.setItem("monthVipExpire", payload.monthVipExpire);
    state.userStatusDesc = payload.userStatusDesc;
    window.sessionStorage.setItem("userStatusDesc", state.userStatusDesc);
    window.localStorage.setItem("userStatusDesc", state.userStatusDesc);
    state.vipExpireDesc = payload.vipExpireDesc;
    window.sessionStorage.setItem("vipExpireDesc", state.vipExpireDesc);
    window.localStorage.setItem("vipExpireDesc", state.vipExpireDesc);
    if(!state.userId&&payload.userId){
      state.userId = payload.userId;
      window.sessionStorage.setItem("userId", payload.userId);
      window.localStorage.setItem("userId", payload.userId);
    }
  },
  logout(state) {
    state.unionId = null;
    window.sessionStorage.removeItem("unionId");
    window.localStorage.removeItem("unionId");
    state.nickName = null;
    window.sessionStorage.removeItem("nickName");
    window.localStorage.removeItem("nickName");
    state.headImgUrl = null;
    window.sessionStorage.removeItem("headImgUrl");
    window.localStorage.removeItem("headImgUrl");
    state.userStatusDesc = null;
    window.sessionStorage.removeItem("userStatusDesc");
    window.localStorage.removeItem("userStatusDesc");
    state.vipExpireDesc = null;
    window.sessionStorage.removeItem("vipExpireDesc");
    window.localStorage.removeItem("vipExpireDesc");
    state.userId = null;
    window.sessionStorage.removeItem("userId");
    window.localStorage.removeItem("userId");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
